/* eslint-disable max-len */
import { Box, Grid, Typography } from '@mui/material';
import { experimentalStyled as styled, useTheme } from '@mui/material/styles';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import DMCA from '@/assets/images/DMCA.svg';
import FaceBookIcon from '@/assets/images/facebook.svg';
import LinkedInIcon from '@/assets/images/linkedIn.svg';
import YoututeIcon from '@/assets/images/youtube.svg';
import ZaloIcon from '@/assets/images/zalo-cmc.svg';
import { FooterLogo } from '@/components/logo-component';
import ScrollableAnchor from '@/components/scroll-anchor';
import useResponsive from '@/hooks/useResponsive';
import { SectionWrapper } from '@/styles/styled';

const RootStyle = styled('div')(() => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  borderTop: 'solid 1px #F2F2F2',
}));

const ListItemTextStyled = styled('div')(() => ({
  fontSize: 16,
  fontWeight: 400,
  marginBottom: '10px',
  color: useTheme().palette.text.primary,
}));

const DocumentFooter = () => {
  const { t } = useTranslation(['footer', 'pop-up']);
  const isDesktop = useResponsive('up', 'sm');
  const theme = useTheme();

  return (
    <ScrollableAnchor id={isDesktop ? 'signup-form' : null}>
      <RootStyle>
        <SectionWrapper>
          <Grid container mt={5} sx={{ pb: 2, borderBottom: '1px solid #F2F2F2' }}>
            <Grid item xs={12} md={7} pb={2}>
              <Grid container className="flex mb-2">
                <Grid item xs={12} md={6}>
                  <Link passHref href="/">
                    <FooterLogo />
                  </Link>
                </Grid>
                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                  <ListItemTextStyled sx={{ mb: 0 }}>
                    <a
                      fontFamily="SVN-Gotham, sanserif"
                      style={{
                        color: '#5E5E5E',
                        fontWeight: 500,
                        fontFamily: 'SVN-Gotham, sanserif',
                      }}
                      href="mailto:support@cmccloud.vn"
                    >
                      support@cmccloud.vn
                    </a>
                    <span style={{ display: 'inline-block', padding: '0 4px 0 4px' }}>|</span>
                    <a
                      href="tel:19002010"
                      style={{
                        color: '#14A8E4',
                        textDecoration: 'none',
                        fontWeight: 700,
                        fontFamily: 'SVN-Gotham, sanserif',
                      }}
                    >
                      1900 2010
                    </a>
                  </ListItemTextStyled>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={5} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
              <Box fontSize={13} sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                <Typography
                  sx={{ mt: 1.5 }}
                  color={theme.palette.text.blue}
                  fontSize={13}
                  fontFamily="SVN-Gotham, sanserif"
                >
                  {t('business_registration_certificate')}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mt: 2, mb: 2 }}
          >
            <Grid item>
              <Box className="flex">
                <Box mt={2} display="flex" alignItems="center">
                  <Link
                    passHref
                    href="https://facebook.com/cmccloud.vn"
                    target="_blank"
                    style={{ marginRight: '10px' }}
                  >
                    <Image width={28} height={28} src={FaceBookIcon} alt="facebook" />
                  </Link>
                  <Link
                    passHref
                    href="https://www.linkedin.com/company/cmc-cloud"
                    target="_blank"
                    style={{ marginRight: '10px' }}
                  >
                    <Image
                      width={28}
                      height={28}
                      src={LinkedInIcon}
                      alt="linkedIn"
                      style={{ width: 'auto', height: 'auto' }}
                    />
                  </Link>
                  <Link
                    passHref
                    href="https://www.youtube.com/channel/UCCTtS8-37x4wfnfr_-fuZ2A"
                    target="_blank"
                    style={{ marginRight: '10px' }}
                  >
                    <Image
                      width={28}
                      height={28}
                      src={YoututeIcon}
                      alt="youtube"
                      style={{ width: 'auto', height: 'auto' }}
                    />
                  </Link>
                  <Link passHref href="https://zalo.me/cmccloud" target="_blank">
                    <Image width={28} height={28} src={ZaloIcon} alt="facebook" />
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid item>
              <Typography>© 2023, CMC Cloud. All rights reserved.</Typography>
            </Grid>
            <Grid item>
              <Link href="https://www.dmca.com/Protection/Status.aspx?ID=0a7fd896-7d19-421c-a76b-7100c2a809cb&refurl=https://cmccloud.vn/">
                <Image
                  alt="Business Registration Certificate"
                  src={DMCA}
                  width={84}
                  height={42}
                  style={{
                    marginLeft: 'auto',
                  }}
                />
              </Link>
            </Grid>
          </Grid>
        </SectionWrapper>
      </RootStyle>
    </ScrollableAnchor>
  );
};

export default DocumentFooter;
